module.exports = __webpack_public_path__ + "static/media/star.4057a8b9.svg";